import styles from './PortfolioNavigation.module.css';

interface IRecieveApplicationsTooltip {
  recieveApplications: boolean;
}

const switchTooltipTextOpen =
  'Currently opened to receive new applications. Once they are opened and managed they will be added to personal portfolio.';
const switchTooltipTextClosed =
  'Currently not available receive new applications. Turn on “Actively receiving” to be distributed applications.';

export function RecieveApplicationsTooltip({
  recieveApplications,
}: IRecieveApplicationsTooltip) {
  return (
    <div className={styles.textTooltip}>
      <p>
        {recieveApplications ? switchTooltipTextOpen : switchTooltipTextClosed}
      </p>
    </div>
  );
}
